<template>
  <div class="header_conntent">
    <div class="logo_content" @click="toggleNavBar">
      <img class="logo" :style="{ transform: `rotate(${logoRotateDeg}deg)` }" src="../../assets/img/路径.png">
    </div>
    <div class="login_user_content">
      <div class="user_conten">
        <div v-if="vip_info.member_status == 1" style="margin-top: 10px">
          <div class="unlidernm">
            <img class="lm" src="../../assets/shape.svg" alt="">
            <div class="mimner">{{ $t('new_header.Unlimited') }}
              <span class="em">
                x{{ vip_info.member_kids }}
              </span>
            </div>
          </div>
          <div class="expirestime">
            {{ user.member_expire_show }}
          </div>
        </div>
        <div class="credit_summary">
          <div class="credit_item credit_total">
            <img class="simei" src="../../assets/img/simei.png" alt="">
            <span class="credit_label">{{ $t('new_header.totalCredit') }}</span>
            <span class="credit_value">{{ user.balance }}</span>
            <span v-if="user.account_expire_at" class="expire_at"> &nbsp;&nbsp;
              {{ user.account_expire_at }}&nbsp;{{ $t('new_header.Expires') }}
            </span>
          </div>
          <div class="credit_item">
            <span class="credit_label">{{ $t('new_header.purchasedCredit') }}</span>
            <span class="credit_chip">
              <img src="../../assets/Ellipse374.png" alt="">
              <span>{{ user.purchased_credit }}</span>
            </span>
          </div>
          <div class="credit_item">
            <span class="credit_label">{{ $t('new_header.rewardCredit') }}</span>
            <span class="credit_chip">
              <img src="../../assets/Ellipse374.png" alt="">
              <span>{{ user.reward_credit }}</span>
            </span>
          </div>
          <div class="credit_item timezone_item">
            <span class="credit_label">{{ $t('index.timeZone') }}</span>
            <span class="timezone_value">(UTC{{ utils.globetime() }})</span>
          </div>
          <button type="button" class="recharge_btn" @click="goRecharge">{{ $t('new_header.recharge') }}</button>
        </div>
        <div class="lang_switch">
          <el-dropdown @command="changeLanguage" trigger="click">
            <span class="el-dropdown-link lang-switch-link">
              <img class="lang-switch-icon" src="../../assets/globe.svg" alt="">
              <span class="lang-switch-text">{{ currentLangLabel }}</span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="zh_CN">{{ $t('information.Simplified_Chinese') }}</el-dropdown-item>
              <el-dropdown-item command="en">{{ $t('information.English') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="use_content">
          <img class="winm_icon" :key="children_info.student_sn || children_info.avatar" :src="children_info.avatar" alt="" @click="changeChildren">
          <div class="router_chilm">
            <el-dropdown @command="chenge_router" trigger="click">
              <span class="el-dropdown-link ziti">
                {{ value1 }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="item" v-for="(item, index) in options" :key="index">{{ isEnglishLocale
                  ?
                  item.label_en:item.label }}</el-dropdown-item>
                <el-dropdown-item command="logout">{{ $t('new_header.Log_out') }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { setStore, getStore, keys, clearStore } from '@/store';
import { getLocaleShortLabel, normalizeLocale, switchUserLanguage } from '@/utils/lang';
import { getGoodsRechargeUrl } from '@/utils/appUrl';
import { logoutAndRedirect } from '@/utils/auth';
export default {
  inject: ['reload'],
  data() {
    return {
      options: [
        {
          value: '/membership',
          label_en: 'Pass Information',
          label: '我的会员套餐'
        },
        {
          value: '/profile',
          label_en: 'Profile',
          label: '修改密码'
        }],
      value1: '',
      user: [],
      vip_info: [],

      user_data: [],
      navBarVisible: true,
      logoRotateDeg: 0,
      children_info: {}

    }
  },

  async created() {
    await this.$http.get('/api/fund?model=lessons').then((res) => {
      if (res.data.code == 200) {
        setStore(keys.userBalance, res.data.data)
      }
    })
    this.user = getStore(keys.userBalance);
    if (this.user.member_type == 0) {
      this.options.splice(0, 1);
    }
    this.value1 = ' +' + getStore(keys.userProfile).country_code + ' ' + getStore(keys.userProfile).mobile;
    var sons = getStore(keys.userProfile);
    this.vip_info = sons;
    console.log(this.user.language)
    // 用户信息
    this.getUser()
  },
  computed: {
    isEnglishLocale () {
      return normalizeLocale(this.$i18n.locale) === 'en'
    },
    currentLangLabel () {
      return getLocaleShortLabel(this.$i18n.locale)
    }
  },
  methods: {
    changeLanguage (lang) {
      switchUserLanguage(this, lang)
    },
    changeChildren() {
      this.$router.push({ path: '/add-children' })
    },
    //获取默认孩子信息
    getUser() {
      this.$http.get('/api/member/data').then((res) => {
        if (res.data.code == 200) {
          this.data = res.data.data
          this.children_info = res.data.data.student_info
            ? { ...res.data.data.student_info }
            : {}
          setStore(keys.userProfile, res.data.data)
          this.up()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error) // 请求失败返回的数据
      })
    },
    toggleNavBar() {
      this.navBarVisible = !this.navBarVisible
      this.logoRotateDeg += 180
      this.$emit('hiddenNavbar', this.navBarVisible)
    },
    goRecharge () {
      window.open(getGoodsRechargeUrl(this.$i18n.locale), '_blank')
    },
    /**
     * 退出登录
     */
    login_out: function () {
      logoutAndRedirect(this)
    },
    /**+{{data.country_code}} {{data.mobile}}
     * 选择跳转页面进行跳转
     */
    chenge_router: function (val) {
      if (val == 'logout') {
        this.login_out()
        return
      }
      this.$router.push({ path: val.value })
      this.reload()

    },

    /**
     * 更新缓存数据
     */
    up: function () {
      var sons = getStore(keys.userProfile);
      this.user = getStore(keys.userBalance);
      this.vip_info = sons;
      if (sons && sons.student_info) {
        this.children_info = { ...sons.student_info }
      }
      this.value1 = '+' + getStore(keys.userProfile).country_code + ' ' + getStore(keys.userProfile).mobile;
    },

  },

}
</script>
<style lang="less" scoped>
.winm_icon {
  cursor: pointer;
  float: left;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
}

.logo_content {
  height: 68px;
  display: flex;
  align-items: center;
  justify-content: center;

  img.logo {
    width: 20px;
    cursor: pointer;
    transition: transform 0.3s ease;
  }
}

.header_conntent {
  width: 100%;
  height: 68px;
  box-sizing: border-box;
  border-bottom: 1px solid #F4F4F4;
  display: flex;
  padding: 0 26px;

  .login_content {
    width: 358px;
    height: 68px;
    background: #FCFCFF;

    .logo {
      margin-top: 19px;
      margin-left: 40px;
    }
  }

  .login_user_content {
    background: #fff;
    height: 68px;
    border: 0px solid red;
    flex: 1;

    .user_conten {
      height: 65px;
      border: 0px solid red;
      float: right;
      display: flex;
      align-items: center;

      .unlidernm {
        width: 150px;
        height: 37px;
        background: #FECE0C;
        border-radius: 18.0828px;
        display: flex;
        align-items: center;

        .lm {
          width: 15.33px;
          height: 11.5px;
          margin-left: 13.22px;
        }

        .mimner {
          margin-left: 10px;
          display: flex;
          font-size: 15px;
          align-items: center;
        }

        .em {
          display: inline-block;
          border: #000000 1px solid;
          width: 23px;
          height: 23px;
          border-radius: 50%;
          text-align: center;
          background: #000;
          color: #FFFFFF;
          line-height: 23px;
          margin-left: 10px;
        }
      }

      .expirestime {
        font-family: Sofia Pro-Regular;
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 25px;
        text-align: center;
        text-transform: capitalize;
        color: #B9B9B9;
      }

      .credit_summary {
        display: flex;
        align-items: center;
        align-self: center;
        margin-left: 25px;
        gap: 12px;
        flex-wrap: nowrap;
        height: 37px;
      }

      .credit_item {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        background: rgba(181, 6, 4, 0.05);
        border-radius: 50px;
        padding: 0 12px;
        height: 37px;
        box-sizing: border-box;
        flex-shrink: 0;
      }

      .credit_total {
        padding: 0 14px 0 9px;
        white-space: nowrap;
      }

      .credit_label,
      .credit_value,
      .expire_at,
      .timezone_value,
      .credit_chip {
        display: inline-flex;
        align-items: center;
        line-height: 1;
      }

      .credit_label {
        color: #787878;
        font-size: 14px;
        white-space: nowrap;
      }

      .credit_value,
      .expire_at {
        color: #B50604;
        font-size: 16px;
        font-weight: 500;
        white-space: nowrap;
      }

      .expire_at {
        font-size: 14px;
      }

      .credit_chip {
        color: #B50604;
        font-size: 16px;
        font-weight: 500;

        img {
          width: 15px;
          height: 15px;
          margin-right: 4px;
          display: block;
        }
      }

      .timezone_item {
        background: #fff;
        border: 1px solid #F0F0F0;
      }

      .timezone_value {
        color: #333;
        font-size: 14px;
        font-weight: 500;
        white-space: nowrap;
      }

      .recharge_btn {
        border: none;
        background: #B50604;
        color: #fff;
        border-radius: 50px;
        padding: 0 16px;
        height: 37px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
        white-space: nowrap;
        flex-shrink: 0;

        &:hover {
          background: #9a0503;
        }
      }

      .simei {
        width: 15px;
        height: 15px;
        flex-shrink: 0;
        display: block;
      }

      .jiner {
        background: rgba(181, 6, 4, 0.05);
        border-radius: 12px;
        color: #B50604;
        cursor: pointer;
        padding: 9px;
        height: 37px;
        box-sizing: border-box;
        border-radius: 50px;
        margin-left: 25px;
        display: flex;
        align-items: center;
        justify-content: center;

        .zidum {
          font-family: Sofia Pro;
          font-style: normal;
          font-weight: 500;
          font-size: 16px;
          margin-left: 4px;
        }
      }

      .use_content {
        height: 37px;
        margin-left: 25px;
        box-sizing: border-box;
        border-radius: 50px;
        width: 200px;
        .icon_user {
          margin-top: 8px;
          margin-left: 10px;
          width: 21px;
          height: 21px;
          float: left;
        }

        /deep/ .el-select {
          float: left;
          margin-top: 3px;
        }

        /deep/ .el-input__inner {
          font-family: Sofia Pro;
          font-style: normal;
          font-weight: normal;
          font-size: 16px;
          color: #000000;
        }

        /deep/ .el-select .el-input.is-focus .el-input__inner {
          border: 0px;
        }

        /deep/ .el-select,
        /deep/ .el-input,
        /deep/ .el-input__inner {
          border: 0px;
          border-radius: 0px;
          border: none;
          text-align: center;
        }
      }

      .log_out_content {
        height: 37px;
        border: 0px solid red;
        margin-left: 25px;
        text-align: center;
        font-family: Sofia Pro;
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        color: #000000;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}


.el-select-dropdown__item.hover {
  background: #ffffff !important;
  color: #4B69FE !important;
  font-weight: bold !important;
}

.lo_out_icon {
  width: 16px;
  height: 14px;
  margin-right: 8px;
}

.router_chilm {
  height: 40px;
  border: 0px solid red;
  float: left;
  line-height: 36px;
  margin-right: 15px;
  margin-left: 7px;
  cursor: pointer;
}

.lang_switch {
  margin-left: 25px;
  display: flex;
  align-items: center;
}

.lang-switch-link {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  color: #B50604;
  font-size: 16px;
  line-height: 1;
}

.lang-switch-icon {
  width: 18px;
  height: 18px;
  margin-right: 6px;
}

.lang-switch-text {
  color: #B50604;
  font-weight: 500;
}

.ziti {
  font-family: Sofia Pro;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: #000000;
}

.el-dropdown-menu {
  padding: 20px;
  border-radius: 8px;
}

.el-dropdown-menu__item {
  font-family: Sofia Pro;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #000000;
  border-radius: 8px;
  padding: 10px 20px;
  line-height: 14px;
}

.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: #B50604 !important;
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/header/header.vue